<template>
  <div>
    <div>
      <div class="color-picker">
        <button class="handler" @click="handleClick">
          <i class="fa fa-phone"></i>
        </button>
        <div class="sec-position">
          <div class="settings-header">
          </div>
          <div class="section">
            <div class="footer-address">
              <a href="tel:(096)%20853-8888" style="color: black!important; padding-left: 0px;">(096) 853-8888</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import $ from 'jquery'

export default {
  methods: {
    handleClick: function () {
      var div = $('.color-picker')
      if (div.css('right') === '-190px') {
        $('.color-picker').animate({right: '0px'}, 150)
      } else {
        $('.color-picker').animate({right: '-190px'}, 150)
      }
    }
  }
}
</script>
<style>
.handler i {
  animation: none !important;
}

.handler, .handler button {
  position: absolute;
  right: 200px;
  width: 50px;
  height: 49px;
  color: white;
  transition: all ease-in 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  z-index: -1;
  border-radius: 50%;
  text-decoration: none;
  background: #00a3f5;
  top: -80px;
  border: 1px solid white;
}

.handler:hover {
  background-color: #00a3f5;
}
</style>



// WEBPACK FOOTER //
// src/components/color.vue